<template>
  <v-form>
    <!-- <v-card-title class="modal-cadastro-titulo">
      Editar  - {{ item.jsonData.fullName }}
    </v-card-title> -->
    <div>
    <v-card-text class="modal-cadastro-form" >
      <v-row>
        <v-col cols="12" class="modal-cadastro-form-col-imput" sm="6">
          <v-text-field dense outlined v-model="item.jsonData.fullName" label="Nome:" @input="$v.item.jsonData.fullName.$touch()" :error-messages="nameErrors" />
        </v-col>

        <v-col cols="12" class="modal-cadastro-form-col-imput" sm="6">
          <v-text-field dense outlined v-model="item.email" @input="$v.item.email.$touch()" label="Email:" :error-messages="emailErrors" />
        </v-col>

        <v-col cols="12" class="modal-cadastro-form-col-imput" sm="6">
          <v-text-field dense outlined v-model="item.jsonData.cpf" label="CPF:" v-mask="['###.###.###-##']" @input="$v.item.jsonData.cpf.$touch()" :error-messages="cpfErrors" />
        </v-col>

        <v-col cols="12" class="modal-cadastro-form-col-imput" sm="6">
          <v-text-field dense outlined v-model="item.jsonData.birth" label="Data de nascimento:" @input="$v.item.jsonData.birth.$touch()" v-mask="['##/##/####']" :error-messages="birthErrors" />
        </v-col>

        <v-col cols="12" class="modal-cadastro-form-col-imput" sm="6">
          <v-text-field dense outlined v-model="item.fullPhone" label="celular:" @input="$v.item.fullPhone.$touch()" v-mask="['(##) ####-####', '(##) #####-####']" :error-messages="celularErrors" />
        </v-col>

        <!-- <v-col cols="12" class="modal-cadastro-form-col-imput" sm="6">
          <v-text-field v-model="data.jsonData.influencer" label="Influenciador:" />
        </v-col> -->

        <v-col cols="12" class="modal-cadastro-form-col-imput" sm="3">
          <v-text-field
            :type="showPassword ? 'text' : 'password'"
            label="Senha"
            v-model="item.jsonData.password"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" dense outlined
            @input="$v.item.jsonData.password.$touch()"
            @click:append="showPassword = !showPassword"
            :error-messages="passwordErrors"
            v-if="permiteAcao({ path: '/gestao/entidades/usuarios-web' }, 'edit')"
          />
        </v-col>

        <v-col cols="12" class="modal-cadastro-form-col-imput" sm="3">
          <v-text-field 
            :type="showPassword ? 'text' : 'password'"
            label="Confirmar Senha:"
            v-model="item.jsonData.passwordConfirmation"
            @input="$v.item.jsonData.passwordConfirmation.$touch()"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" dense outlined
            :error-messages="passwordConfirmationErrors"
            @click:append="showPassword = !showPassword"
            v-if="permiteAcao({ path: '/gestao/entidades/usuarios-web' }, 'edit')"
          />
        </v-col>

        
      </v-row>

      <v-divider></v-divider>

      <h3 class="titulo text-center my-2">Permissões</h3>
      <v-row>
        <v-col class="d-flex justify-center" cols="12" sm="3"><v-chip><v-switch v-model="data.jsonFlags.canLogin" label="Login"></v-switch></v-chip> </v-col>
        <v-col class="d-flex justify-center" cols="12" sm="3"><v-chip><v-switch v-model="data.jsonFlags.canWithdraw" label="Saque"></v-switch></v-chip> </v-col>
        <v-col class="d-flex justify-center" cols="12" sm="3"><v-chip><v-switch v-model="data.jsonFlags.canDeposit" label="Deposito"></v-switch></v-chip> </v-col>
        <v-col class="d-flex justify-center" cols="12" sm="3"><v-chip><v-switch v-model="data.jsonFlags.canPlay" label="Jogar"></v-switch></v-chip> </v-col>
      </v-row>

      <v-divider></v-divider>

      <h3 class="titulo text-center my-2">Resumo Financeiro</h3>
      <v-skeleton-loader
        :loading="loadingFinancialResume"
        :transition="'fade-transition'"
        height="100"
        type="table"
      >
        <v-row>
          <v-col cols="12" class="modal-cadastro-form-col-imput d-flex justify-center mb-2" sm="3">
            <v-chip> Saldo: {{ financialResume.acc_balance | currency }} </v-chip>
          </v-col>
          <v-col cols="12" class="modal-cadastro-form-col-imput d-flex justify-center mb-2" sm="3">
            <v-chip> Depositos: {{ financialResume.deposits | currency }} </v-chip>
          </v-col>
          <v-col cols="12" class="modal-cadastro-form-col-imput d-flex justify-center mb-2" sm="3">
            <v-chip> Saques: {{ financialResume.withdraw | currency }} </v-chip>
          </v-col>
          <v-col cols="12" class="modal-cadastro-form-col-imput d-flex justify-center mb-2" sm="3">
            <v-chip> Vl. Apostas: {{ financialResume.vl_games | currency }} </v-chip>
          </v-col>
          <v-col cols="12" class="modal-cadastro-form-col-imput d-flex justify-center mb-2" sm="3">
            <v-chip> Vl. Premios: {{ financialResume.vl_prizes | currency }} </v-chip>
          </v-col>
          <v-col cols="12" class="modal-cadastro-form-col-imput d-flex justify-center mb-2" sm="3">
            <v-chip> Bônus: {{ financialResume.bonus | currency }} </v-chip>
          </v-col>
          <v-col cols="12" class="modal-cadastro-form-col-imput d-flex justify-center mb-2" sm="3">
            <v-chip> Payout: {{ formatPercent(financialResume.payout) }} </v-chip>
          </v-col>
        </v-row>
      </v-skeleton-loader>
    </v-card-text>
  </div>
    <v-card-actions class="modal-cadastro-footer">
      <v-btn :color="variables.colorPrimary" @click="$emit('closeModal')" class="br-btn br-btn-cancelar">Cancelar</v-btn>
      <v-btn type="submit" :color="variables.colorPrimary"  @click.prevent="submit" class="br-btn" :loading="loading" v-if="permiteAcao({ path: '/gestao/entidades/usuarios-web' }, 'edit')">Salvar</v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, email, minLength, sameAs, requiredIf } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
import Events from '@/core/service/events'
import variables from '@/assets/styles/helpers/_variables.scss'
import moment from 'moment'
import { filter } from 'lodash'


import validate from './validate'

export default {
  name: 'UsuarioWebDadosPessoais',
  mixins: [validationMixin],
  directives: {
    mask
  },
  components: {
    // eslint-disable-next-line vue/no-unused-components
    vmoney: () => import('@/views/components/vMoney')
  },
  props: {
    data: {
      type: Object,
      default: (() => {}),
    }
  },
  data: () => ({
    loading: false,
    showPassword: false,
    loadingFinancialResume: false,
  }),
  mounted () {
    Events.$on('validarCloseModel', () => {
      this.$nextTick(() => {
        this.$v.$reset()
        // this.openUser()
      })
    })
    
    this.openUser()
  },
  computed: {
    ...mapGetters('usuariosWeb', {
      item: 'item',
      totalItens: 'totalItens',
      financialResume: 'financialResume'
    }),
    ...mapGetters('roles', ['permiteAcao']),
    ...mapGetters('filter', ['objFilter']),
    ...mapGetters('pagination', ['page']),

    ...validate,

    variables: () => variables,
  },
  methods: {
    ...mapActions('usuariosWeb', ['getItens', 'editarItem', 'deletarItem', 'clearItens', 'getItem', 'editSaveItem', 'setItem', 'getFinancialResume']),

    submit () {
      const self = this
      if (self.$v.$invalid) {
        self.$v.$touch()
        return false
      }

      this.loading = true
      self.usuarioEditSave(this.item)
    },

    openUser () {
      this.loadingFinancialResume = true
      this.getFinancialResume({ entityId: this.data.id })
        .finally(() => { this.loadingFinancialResume = false })

      if (this.data.jsonFlags.canLogin !== false) this.data.jsonFlags.canLogin = true
      if (this.data.jsonFlags.canWithdraw !== false) this.data.jsonFlags.canWithdraw = true
      if (this.data.jsonFlags.canDeposit !== false) this.data.jsonFlags.canDeposit = true
      if (this.data.jsonFlags.canPlay !== false) this.data.jsonFlags.canPlay = true
    },

    formatLastName (name) {
      let val = String(name).split(' ')
      return { name: val[0], lastName: filter(val, (v, k) => k !== 0).join(' ') }
    },

    formatPercent(val) {
      const percent = Number(val) * 100 
      return percent.toFixed(2) + ' %'
    },

    usuarioEditSave (val) {
      const self = this
      const dados = Object.assign({}, val)
      dados.jsonData.dddPhone = this.item.fullPhone.replace(/\D/g, '').substring(0, 2),
      dados.jsonData.phone = this.item.fullPhone.replace(/\D/g, '').substring(2, this.item.fullPhone.replace(/\D/g, '').length)
      dados.jsonData.cpf = this.item.jsonData.cpf.replace(/\D/g, '')
      dados.jsonData.email = this.item.email
      dados.jsonData.birth = moment(this.item.jsonData.birth, 'DD/MM/YYYY').format('YYYY-MM-DD')

      if(this.item.jsonData.password !== ''){
        dados.jsonData.password = this.item.jsonData.password
        dados.jsonData.passwordConfirmation = this.item.jsonData.passwordConfirmation
      }
      delete dados.fullPhone
      
      if (dados.jsonData.fullName) {
        const nomeSobrenome = this.formatLastName(this.item.jsonData.fullName)
        dados.jsonData.name = nomeSobrenome.name
        dados.jsonData.lastName = nomeSobrenome.lastName
        dados.jsonData.fullName = `${nomeSobrenome.name || ''} ${nomeSobrenome.lastName || ''}`
      }

      self.editSaveItem(dados).then(() => {
        self.$emit('closeModal')
        self.loading = false
        // this.getItens({ page: this.page, pageSize: this.$store.getters.ItensPaginacao, ...this.objFilter })
        Events.$emit('UsuarioWeb::buscarUsuarioAtualizado', dados.jsonData.cpf)
        Events.$emit('snackbarCadastro::msg', {
          toggle: true,
          type: 'success',
          msg: 'Edição realizado com sucesso!'
        })
      }).catch(err => {
        self.loading = false
        Events.$emit('snackbarCadastro::msg', {
          toggle: true,
          type: 'error',
          msg: err.error
        })
      })
    },
  },

  validations () {
    return{
      item: {
        email: { required, email },
        fullPhone: { required },
        jsonData: {
          fullName: { required },
          cpf: { required },
          birth: { required , minLength: minLength(9)},
          // phone: { required, minLength: minLength(14) },
          password: {required: requiredIf( function() {
            return this.item.jsonData.passwordConfirmation 
          })},
          passwordConfirmation: { sameAsPassword: sameAs('password')},
        }
      }
    }
  }
}
</script>
